import { TFunction } from 'i18next';
import { Asset } from 'graphql-common';
import _get from 'lodash/get';
import Icons from '@lib/components/Icons/Icons';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import { TooltipProps } from '@lib/components/Tooltip/Tooltip';

type ActionsMenuArgs = {
  getQrCode: (v?: Asset) => void;
  onViewHandler: (v?: Asset) => void;
  onEditHandler: (v?: Asset) => void;
  onDelete: (v?: Asset) => void;
  t: TFunction<'translation', undefined>;
  isViewOnly: boolean;
};

export default function getActionsMenu({
  getQrCode,
  onViewHandler,
  onEditHandler,
  onDelete,
  t,
  isViewOnly,
}: ActionsMenuArgs): NavItem<Asset>[] {
  return [
    {
      id: 'view-action',
      title: t('view'),
      onClick: (item?: Asset) => onViewHandler(item),
      leftIcon: Icons.view,
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'edit-action',
      title: t('edit'),
      onClick: (item?: Asset) => onEditHandler(item),
      leftIcon: Icons.edit,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => !isViewOnly,
    },
    {
      id: 'get-qr-code-action',
      title: t('get-qr-code'),
      onClick: (item?: Asset) => getQrCode(item),
      leftIcon: Icons.qrCode,
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'delete-action',
      title: t('delete'),
      onClick: (item?: Asset) => onDelete(item),
      leftIcon: Icons.delete,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => !isViewOnly,
      predictorFnDisable: (item?: Asset) =>
        _get(item, 'canDestroy.value', true) === false,
      predictorFnDisableTooltipProps: (item?: Asset) =>
        !item?.canDestroy?.value
          ? ({
              body: t('asset-disabled-destroy-desc'),
              placement: 'left',
            } as Omit<TooltipProps, 'children'>)
          : undefined,
    },
  ];
}
